// @ts-ignore no-type
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollaborationSidebarWithWrapper({
  children
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    position: "relative",
    children: [children, /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        CollaborationSidebarContainer
      }) => /*#__PURE__*/_jsx(CollaborationSidebarContainer, {})
    })]
  });
}